// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__yb-ra","col":"Table_col__LiGva","fulfillmentStatus":"Table_fulfillmentStatus__1Aqta","emailCol":"Table_emailCol__3xuCu"};